import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { MEDIA } from "../../constants/media";
import { slugify } from "../../lib/utils";
import { ArrowRight } from "lucide-react";

const SECTORS = [
  { name: "Restauração", emoji: "🍽️", img: MEDIA.categoryRestauracao, count: null },
  { name: "Logística", emoji: "🚚", img: MEDIA.categoryLogistica, count: null },
  { name: "Retalho", emoji: "🛒", img: MEDIA.categoryRetalho, count: null },
  { name: "Hotelaria", emoji: "🏨", img: MEDIA.categoryHotelaria, count: null },
  { name: "Apoio ao Cliente", emoji: "🎧", img: MEDIA.categoryApoioCliente, count: null },
  { name: "Construção", emoji: "🏗️", img: MEDIA.categoryConstrucao, count: null },
  { name: "Limpeza", emoji: "🧹", img: MEDIA.categoryLimpeza, count: null },
  { name: "Saúde", emoji: "🏥", img: MEDIA.categorySaude, count: null },
];

export const Sectors = () => {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api.get("/stats/categories")
      .then((r) => {
        const m = {};
        (r.data.categories || []).forEach((c) => { m[c.category] = c.count; });
        setCounts(m);
      })
      .catch(() => {});
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-amber-600 mb-2">Setores em destaque</p>
          <h2 className="font-heading font-black tracking-tighter text-2xl sm:text-3xl text-slate-900">
            Onde estão as oportunidades
          </h2>
        </div>
        <Link to="/empregos" className="text-sm font-medium text-slate-600 hover:text-amber-600 flex items-center gap-1 transition-colors">
          Ver todas <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {SECTORS.map((s) => {
          const count = counts[s.name];
          return (
            <Link key={s.name} to={`/empregos-de/${slugify(s.name)}`}
              data-testid={`sector-card-${s.name}`}
              className="group relative overflow-hidden rounded-2xl aspect-[4/3] cursor-pointer">
              {/* Image */}
              <img src={s.img} alt={s.name} loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/30 to-transparent" />
              <div className="absolute inset-0 bg-slate-950/0 group-hover:bg-slate-950/20 transition-colors" />
              {/* Badge com quantidade de vagas */}
              {count != null && (
                <div data-testid={`sector-count-${s.name}`}
                  className="absolute top-3 right-3 rounded-full bg-white/90 backdrop-blur px-2.5 py-1 text-xs font-bold text-slate-900 shadow-sm">
                  {count} {count === 1 ? "vaga" : "vagas"}
                </div>
              )}
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="text-lg">{s.emoji}</p>
                <p className="font-heading font-bold text-white text-sm mt-0.5 leading-tight">{s.name}</p>
                <p className="flex items-center gap-1 text-white/70 text-xs mt-1 group-hover:text-amber-300 transition-colors">
                  {count != null && count > 0
                    ? <>Explorar {count} {count === 1 ? "vaga" : "vagas"} <ArrowRight className="w-3 h-3" /></>
                    : <>Explorar vagas <ArrowRight className="w-3 h-3" /></>}
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
